import React from 'react';

import { useTranslation } from 'next-i18next';

import Strip from '../../common/Strip';
import TextHeader from '../../common/TextHeader';
import { Link } from '../../elements';
import Styles from './WhyChooseUs.module.scss';

const WhyChooseUs = () => {
  const { t } = useTranslation('clients');
  const {
    whyChooseUs: { title, button, cta, items },
  } = t('corporate-treasurers', {
    returnObjects: true,
  }) as any;

  return (
    <Strip variant="white" style={{ paddingTop: 40 }}>
      <TextHeader level={2} data={{ title }} />
      <div className={Styles.items}>
        {items.map((item: { label: any; icon: any }) => (
          <div key={item.label} className={Styles.item}>
            <img alt={item.label} src={`/images/client/${item.icon}`} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>

      <Link variant={['ctaMint', 'dark', 'centered']} to={cta}>
        {button}
      </Link>
    </Strip>
  );
};

export default WhyChooseUs;
